<template>
  <div>
    <div class="dont-print">
    
      Period being selected: <input type="radio" id="selectByDate1" value="transaction_date" v-model="queryOptions.selectByDate">
      <label for="selectByDate1">Transaction Date</label>
      
      <input type="radio" id="selectByDate2" value="settlement_date" v-model="queryOptions.selectByDate">
      <label for="selectByDate2">Settlement Date</label>
      <!-- {{queryOptions.selectByDate}} -->
      
      <br>
      How Transactions Are Grouped: <input type="radio" id="groupByDate1" value="transaction_date" v-model="queryOptions.groupByDate">
      <label for="groupByDate1">Transaction Date</label>
      
      <input type="radio" id="groupByDate2" value="settlement_date" v-model="queryOptions.groupByDate">
      <label for="groupByDate2">Settlement Date</label>
      <!-- {{queryOptions.groupByDate}} -->
      <br>
      <button @click="store.loadData()"> Reload Data</button>
      <br>
      
    </div>
    <div>
      Data Selected for the {{capitalize(store.timestamps.dateKey)}} by the 
      {{queryOptions.selectByDate === "transaction_date" ? "Transaction" : "Settlement"}} Date.
      <br>
      Each Day Grouped by 
      {{queryOptions.groupByDate === "transaction_date" ? "Transaction" : "Settlement"}}.
    </div>
  
  </div>
  
</template>

<script>
import formatDataMixin from '@/mixins/formatDataMixin.js'

export default {
  name:'POSTransactionSettlementToggler',
  inject: ['page'],
  mixins : [formatDataMixin],
  props:[
    'storeName',
  ],
  computed:{
    store(){return this.page.$refs[this.storeName]},
    queryOptions(){ return this.store.queryOptions},
  },
}
</script>